{
  "raporharitapersonel": {
    "Baslik": "Personnel Map Report",
    "Arama": "Search",
    "Filtrele": "Filter",
    "Yenile": "Refresh",
    "Kullanici": "User",
    "Tarih": "Date",
    "Uygula": "Apply",
    "Temizle": "Clear",
    "Marker": "Marker",
    "Polyline": "Route",
    "HaritaKatmanlari": "Map Layers",
    "SokakHaritasi": "Street Map",
    "UyduGoruntusu": "Satellite View",
    "TopografikHarita": "Topographic Map",
    "Cap": "Accuracy",
    "Kapat": "Close"
  }
}
